import { useApolloClient } from '@apollo/client';
import { EMPLOYEE_QUERY } from 'containers/manage-employees/employees-queries';
import useOnMount from 'hooks/utils/useOnMount/useOnMount';
import first from 'lodash/first';
import { useState } from 'react';
import { IMember } from 'types';

export default function useGetMember(memberId: string | null) {
  const client = useApolloClient();
  const [member, setMember] = useState<IMember | null>(null);

  async function getMember() {
    if (memberId === null) {
      return null;
    }
    const memberQuery = await client.query<{ members: IMember[] }>({
      query: EMPLOYEE_QUERY,
      variables: {
        memberId,
      },
    });

    setMember(first(memberQuery.data.members)!);
  }

  useOnMount(() => {
    getMember();
  });

  return member;
}
